export enum SpecialProgrammesFilterOptionValue {
	EXECUTIVE_PROGRAMMES = 'executive',
	JOINT_PROGRAMMES = 'joint',
	ERASMUS_MUNDUS = 'erasmus',
}
